function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const buttonName = event.currentTarget.name;

    if (buttonName === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && buttonName === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

var CartPerformance = window.CartPerformance || {
  createStartingMarker(name) {
    try {
      performance.mark(name);
    } catch (error) {}

    return name;
  },

  measure(name, callback) {
    if (typeof callback === 'function') {
      callback();
    }
  },

  measureFromMarker(name, marker) {
    try {
      performance.measure(name, marker);
    } catch (error) {}
  },

  measureFromEvent(name, event) {
    try {
      performance.measure(name, {
        start: event && event.timeStamp ? event.timeStamp : performance.now(),
      });
    } catch (error) {}
  },
};

window.CartPerformance = CartPerformance;

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      const inlineSubmenus =
        this.matches('header-drawer') ||
        this.classList.contains('mobile-facets__wrapper') ||
        this.closest('header-drawer') ||
        this.closest('.mobile-facets__wrapper');

      if (inlineSubmenus) {
        if (isOpen) {
          detailsElement.classList.remove('menu-opening');
          summaryElement.setAttribute('aria-expanded', false);
          return;
        }

        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
        });
        return;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.slider.addEventListener('mousedown', this.onDragStart.bind(this));
    this.slider.addEventListener('mousemove', this.onDragMove.bind(this));
    this.slider.addEventListener('mouseup', this.onDragEnd.bind(this));
    this.slider.addEventListener('mouseleave', this.onDragEnd.bind(this));

    this.slider.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
    this.slider.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
    this.slider.addEventListener('touchend', this.onTouchEnd.bind(this));
  }

  onDragStart(event) {
    if (event.button !== undefined && event.button !== 0) return;
    this.isMouseDown = true;
    this.isDragging = false;
    this.startX = event.pageX - this.slider.offsetLeft;
    this.startClientY = event.clientY;
    this.scrollStart = this.slider.scrollLeft;
  }

  onDragMove(event) {
    if (!this.isMouseDown) return;

    const x = event.pageX - this.slider.offsetLeft;
    const dragDistance = x - this.startX;
    const verticalDistance = event.clientY - this.startClientY;

    if (!this.isDragging) {
      if (Math.abs(dragDistance) < 8 && Math.abs(verticalDistance) < 8) return;
      if (Math.abs(dragDistance) <= Math.abs(verticalDistance)) return;

      this.isDragging = true;
      this.slider.style.cursor = 'grabbing';
      this.slider.style.userSelect = 'none';
      this.slider.style.scrollSnapType = 'none';
    }

    event.preventDefault();
    const walk = dragDistance * 1.5;
    this.slider.scrollLeft = this.scrollStart - walk;
  }

  onDragEnd() {
    if (!this.isMouseDown && !this.isDragging) return;

    const wasDragging = this.isDragging;
    this.isMouseDown = false;
    this.isDragging = false;
    this.slider.style.cursor = '';
    this.slider.style.userSelect = '';

    if (!wasDragging) {
      this.slider.style.scrollSnapType = '';
      return;
    }

    this.snapAfterDrag(this.scrollStart, this.slider.scrollLeft);
  }

  onTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.touchScrollStart = this.slider.scrollLeft;
    this.isTouchDragging = false;
  }

  onTouchMove(event) {
    const diff = this.touchStartX - event.touches[0].clientX;
    const verticalDiff = this.touchStartY - event.touches[0].clientY;

    if (!this.isTouchDragging) {
      if (Math.abs(diff) < 8 && Math.abs(verticalDiff) < 8) return;
      if (Math.abs(diff) <= Math.abs(verticalDiff)) return;

      this.isTouchDragging = true;
      this.slider.style.scrollSnapType = 'none';
    }

    this.slider.scrollLeft = this.touchScrollStart + diff;
  }

  onTouchEnd() {
    if (!this.isTouchDragging) {
      this.slider.style.scrollSnapType = '';
      return;
    }

    this.isTouchDragging = false;
    this.snapAfterDrag(this.touchScrollStart, this.slider.scrollLeft);
  }

  snapAfterDrag(scrollStart, currentScroll) {
    const slideWidth = this.sliderItemOffset;
    const dragDistance = scrollStart - currentScroll;
    const threshold = slideWidth * 0.15;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    let targetPosition;
    if (dragDistance > threshold) {
      targetPosition = isLastSlide ? 0 : scrollStart + slideWidth;
    } else if (dragDistance < -threshold) {
      targetPosition = isFirstSlide ? slideWidth * (this.sliderItemsToShow.length - 1) : scrollStart - slideWidth;
    } else {
      targetPosition = scrollStart;
    }

    this.slider.scrollTo({ left: targetPosition, behavior: 'smooth' });
    setTimeout(() => {
      this.slider.style.scrollSnapType = '';
    }, 600);
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({ left: position });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => { this.announcementBarArrowButtonWasClicked = true; }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
    this.restartAutoplay();

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({ left: position });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearTimeout(this.autoplay);
    this.autoplay = setTimeout(() => {
      this.autoRotateSlides();
      this.play();
    }, this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearTimeout(this.autoplay);
  }

  restartAutoplay() {
    if (!this.slider || this.slider.getAttribute('data-autoplay') !== 'true') return;
    if (this.reducedMotion && this.reducedMotion.matches) return;
    if (this.sliderAutoplayButton && !this.autoplayButtonIsSetToPlay) return;
    this.play();
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach((button) => { button.removeAttribute('tabindex'); });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach((button) => { button.setAttribute('tabindex', '-1'); });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';
    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;
    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);
    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    this.restartAutoplay();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  }

  snapAfterDrag(scrollStart, currentScroll) {
    const slideWidth = this.sliderItemOffset;
    const dragDistance = scrollStart - currentScroll;
    const threshold = slideWidth * 0.15;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    let targetPosition;
    if (dragDistance > threshold) {
      targetPosition = isLastSlide ? 0 : scrollStart + slideWidth;
    } else if (dragDistance < -threshold) {
      targetPosition = isFirstSlide ? slideWidth * (this.sliderItemsToShow.length - 1) : scrollStart - slideWidth;
    } else {
      targetPosition = scrollStart;
    }

    this.slider.scrollTo({ left: targetPosition, behavior: 'smooth' });
    setTimeout(() => {
      this.slider.style.scrollSnapType = '';
    }, 600);
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__slider`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.options[0]
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant.options[index - 1] === previousOptionSelected)
        .map((variantForFilter) => variantForFilter.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${sectionId}`);
        const skuSource = html.getElementById(`Sku-${sectionId}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${sectionId}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(`Volume-${sectionId}`);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${sectionId}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const stockCountDestination = document.getElementById(`Stock-${this.dataset.section}`);
        const stockCountSource = html.getElementById(`Stock-${sectionId}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (volumePricingSource && volumePricingDestination)
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        if (stockCountSource && stockCountDestination) stockCountDestination.innerHTML = stockCountSource.innerHTML;

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination
            .querySelectorAll('[id^="PricePerItem-"]')
            .forEach((pricePerItemContent, index) => {
              pricePerItemContent.id = `PricePerItem-${this.dataset.section}`;
            });
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span, [name="add"] > .btn-text');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && addButtonText) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button && button.querySelector('[name="add"]');
    const addButtonText = button && button.querySelector('[name="add"] > span, [name="add"] > .btn-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const stockCount = document.getElementById(`Stock-${this.dataset.section}`);

    if (!addButton) return;
    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (volumeNote) volumeNote.classList.add('visibility-hidden');
    if (volumeTable) volumeTable.classList.add('visibility-hidden');
    if (stockCount) stockCount.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* BIGSHOCKED: responsive slideshow swipe snap */
(function () {
  function getPoint(event) {
    if (event && event.touches && event.touches.length) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }

    if (event && event.changedTouches && event.changedTouches.length) {
      return {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      };
    }

    if (event && typeof event.clientX === 'number') {
      return {
        x: event.clientX,
        y: event.clientY
      };
    }

    return null;
  }

  function rememberGestureStart(component, event) {
    var point = getPoint(event);
    if (!point) return;

    component.bigshockedSwipeGesture = {
      startX: point.x,
      startY: point.y,
      lastX: point.x,
      lastY: point.y,
      startIndex: getCurrentSlideIndex(component),
      startTime: Date.now(),
      lastTime: Date.now()
    };
  }

  function rememberGestureMove(component, event) {
    var point = getPoint(event);
    if (!point || !component.bigshockedSwipeGesture) return;

    component.bigshockedSwipeGesture.lastX = point.x;
    component.bigshockedSwipeGesture.lastY = point.y;
    component.bigshockedSwipeGesture.lastTime = Date.now();
  }

  function isQuickHorizontalSwipe(component) {
    var gesture = component.bigshockedSwipeGesture;
    if (!gesture) return false;

    var deltaX = gesture.startX - gesture.lastX;
    var deltaY = gesture.startY - gesture.lastY;
    var duration = Math.max(1, gesture.lastTime - gesture.startTime);
    var isSlideshow = component.tagName && component.tagName.toLowerCase() === 'slideshow-component';
    var quickSwipeDistance = isSlideshow ? 10 : 22;
    var quickSwipeVelocity = isSlideshow ? 0.08 : 0.18;
    var horizontalGesture = Math.abs(deltaX) > Math.abs(deltaY) * 1.1;

    return (
      horizontalGesture &&
      Math.abs(deltaX) >= quickSwipeDistance &&
      Math.abs(deltaX) / duration >= quickSwipeVelocity
    );
  }

  function getCurrentSlideIndex(component) {
    if (typeof component.currentPage === 'number' && component.currentPage > 0) {
      return component.currentPage - 1;
    }

    if (!component.sliderItemOffset) return 0;
    return Math.round(component.slider.scrollLeft / component.sliderItemOffset);
  }

  function getSlidePosition(component, targetIndex) {
    var targetSlide = component.sliderItemsToShow[targetIndex];
    return targetSlide ? targetSlide.offsetLeft : targetIndex * component.sliderItemOffset;
  }

  function removeDuplicateIds(element) {
    if (!element) return;
    element.removeAttribute('id');
    element.querySelectorAll('[id]').forEach((child) => child.removeAttribute('id'));
  }

  function animateSlideshowBoundary(component, targetIndex, direction) {
    if (
      !component ||
      !component.slider ||
      !component.sliderItemsToShow ||
      !component.sliderItemsToShow[targetIndex] ||
      component.bigshockedBoundaryAnimating
    ) {
      return false;
    }

    var currentIndex = Math.max(0, Math.min(getCurrentSlideIndex(component), component.sliderItemsToShow.length - 1));
    var currentSlide = component.sliderItemsToShow[currentIndex];
    var targetSlide = component.sliderItemsToShow[targetIndex];

    if (!currentSlide || !targetSlide || currentSlide === targetSlide) return false;

    component.bigshockedBoundaryAnimating = true;
    if (typeof component.pause === 'function') component.pause();

    var overlay = document.createElement('div');
    var currentClone = currentSlide.cloneNode(true);
    var targetClone = targetSlide.cloneNode(true);
    var targetStart = direction === 'next' ? '100%' : '-100%';
    var currentEnd = direction === 'next' ? '-100%' : '100%';

    removeDuplicateIds(currentClone);
    removeDuplicateIds(targetClone);

    overlay.className = 'bigshocked-slideshow-loop-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = [
      'position:absolute',
      'inset:0',
      'z-index:30',
      'overflow:hidden',
      'pointer-events:none',
      'background:#000'
    ].join(';');

    [currentClone, targetClone].forEach((clone) => {
      clone.style.cssText = [
        'position:absolute',
        'inset:0',
        'width:100%',
        'height:100%',
        'margin:0',
        'display:block',
        'transition:transform 320ms ease',
        'will-change:transform',
        'scroll-snap-align:none'
      ].join(';');
      clone.setAttribute('aria-hidden', 'true');
    });

    currentClone.style.transform = 'translateX(0)';
    targetClone.style.transform = 'translateX(' + targetStart + ')';

    overlay.appendChild(currentClone);
    overlay.appendChild(targetClone);

    var previousPosition = component.style.position;
    var previousVisibility = component.slider.style.visibility;
    if (!previousPosition) component.style.position = 'relative';
    component.slider.style.visibility = 'hidden';
    component.appendChild(overlay);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        currentClone.style.transform = 'translateX(' + currentEnd + ')';
        targetClone.style.transform = 'translateX(0)';
      });
    });

    window.setTimeout(() => {
      var targetPosition = getSlidePosition(component, targetIndex);
      var previousScrollBehavior = component.slider.style.scrollBehavior;

      component.slider.style.scrollBehavior = 'auto';
      component.slider.scrollTo({ left: targetPosition, behavior: 'auto' });
      component.currentPage = targetIndex + 1;
      component.update();

      component.slider.style.visibility = previousVisibility;
      component.slider.style.scrollBehavior = previousScrollBehavior;
      if (!previousPosition) component.style.position = '';
      overlay.remove();
      component.bigshockedBoundaryAnimating = false;

      if (typeof component.restartAutoplay === 'function') {
        component.restartAutoplay();
      } else if (
        typeof component.play === 'function' &&
        component.slider &&
        component.slider.getAttribute('data-autoplay') === 'true'
      ) {
        component.play();
      }
    }, 340);

    return true;
  }

  function patchGestureTracking(ComponentClass) {
    if (!ComponentClass || ComponentClass.prototype.bigshockedSwipeTrackingPatched) return;

    var originalDragStart = ComponentClass.prototype.onDragStart;
    var originalDragMove = ComponentClass.prototype.onDragMove;
    var originalDragEnd = ComponentClass.prototype.onDragEnd;
    var originalTouchStart = ComponentClass.prototype.onTouchStart;
    var originalTouchMove = ComponentClass.prototype.onTouchMove;
    var originalTouchEnd = ComponentClass.prototype.onTouchEnd;

    ComponentClass.prototype.onDragStart = function (event) {
      rememberGestureStart(this, event);
      return originalDragStart.call(this, event);
    };

    ComponentClass.prototype.onDragMove = function (event) {
      rememberGestureMove(this, event);
      return originalDragMove.call(this, event);
    };

    ComponentClass.prototype.onDragEnd = function (event) {
      var wasDragging = this.isDragging;
      rememberGestureMove(this, event);
      var result = originalDragEnd.call(this, event);

      if (!wasDragging && isQuickHorizontalSwipe(this)) {
        fixedSnapAfterDrag.call(this, this.scrollStart || this.slider.scrollLeft, this.slider.scrollLeft);
      }

      return result;
    };

    ComponentClass.prototype.onTouchStart = function (event) {
      rememberGestureStart(this, event);
      return originalTouchStart.call(this, event);
    };

    ComponentClass.prototype.onTouchMove = function (event) {
      rememberGestureMove(this, event);
      return originalTouchMove.call(this, event);
    };

    ComponentClass.prototype.onTouchEnd = function (event) {
      var wasTouchDragging = this.isTouchDragging;
      rememberGestureMove(this, event);
      var result = originalTouchEnd.call(this, event);

      if (!wasTouchDragging && isQuickHorizontalSwipe(this)) {
        fixedSnapAfterDrag.call(this, this.touchScrollStart || this.slider.scrollLeft, this.slider.scrollLeft);
      }

      return result;
    };

    ComponentClass.prototype.bigshockedSwipeTrackingPatched = true;
  }

  function fixedSnapAfterDrag(scrollStart, currentScroll) {
    if (
      !this.slider ||
      !this.sliderItemsToShow ||
      !this.sliderItemsToShow.length ||
      !this.sliderItemOffset
    ) {
      return;
    }

    var slideWidth = this.sliderItemOffset;
    var maxIndex = this.sliderItemsToShow.length - 1;
    var dragDelta = currentScroll - scrollStart;
    var gesture = this.bigshockedSwipeGesture;
    var gestureDeltaX = 0;
    var gestureDeltaY = 0;
    var gestureDuration = 0;

    if (gesture) {
      gestureDeltaX = gesture.startX - gesture.lastX;
      gestureDeltaY = gesture.startY - gesture.lastY;
      gestureDuration = Math.max(1, gesture.lastTime - gesture.startTime);
    }

    var isSlideshow = this.tagName && this.tagName.toLowerCase() === 'slideshow-component';
    var distanceThreshold = Math.min(slideWidth * (isSlideshow ? 0.035 : 0.08), isSlideshow ? 48 : 80);
    var quickSwipeDistance = isSlideshow ? 10 : 22;
    var quickSwipeVelocity = isSlideshow ? 0.08 : 0.18;
    var horizontalGesture = Math.abs(gestureDeltaX) > Math.abs(gestureDeltaY) * 1.1;
    var quickSwipe =
      horizontalGesture &&
      Math.abs(gestureDeltaX) >= quickSwipeDistance &&
      Math.abs(gestureDeltaX) / gestureDuration >= quickSwipeVelocity;
    var directionDelta = Math.abs(dragDelta) >= 2 ? dragDelta : gestureDeltaX;
    var startIndex = isSlideshow && gesture && typeof gesture.startIndex === 'number'
      ? gesture.startIndex
      : isSlideshow
        ? getCurrentSlideIndex(this)
        : Math.round(scrollStart / slideWidth);
    var targetIndex = startIndex;
    var edgeToLast =
      isSlideshow &&
      horizontalGesture &&
      Math.abs(gestureDeltaX) >= quickSwipeDistance &&
      startIndex === 0 &&
      gestureDeltaX > 0;
    var edgeToFirst =
      isSlideshow &&
      horizontalGesture &&
      Math.abs(gestureDeltaX) >= quickSwipeDistance &&
      startIndex === maxIndex &&
      gestureDeltaX < 0;

    if (edgeToLast) {
      targetIndex = maxIndex;
    } else if (edgeToFirst) {
      targetIndex = 0;
    } else if (Math.abs(dragDelta) >= distanceThreshold || quickSwipe) {
      if (isSlideshow) {
        targetIndex = directionDelta < 0 ? startIndex + 1 : startIndex - 1;
      } else {
        targetIndex = directionDelta > 0 ? startIndex + 1 : startIndex - 1;
      }
    }

    if (this.enableSliderLooping) {
      if (targetIndex > maxIndex) targetIndex = 0;
      if (targetIndex < 0) targetIndex = maxIndex;
    } else {
      targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));
    }

    if (edgeToLast && animateSlideshowBoundary(this, targetIndex, 'previous')) {
      this.bigshockedSwipeGesture = null;
      return;
    }

    if (edgeToFirst && animateSlideshowBoundary(this, targetIndex, 'next')) {
      this.bigshockedSwipeGesture = null;
      return;
    }

    var targetSlide = this.sliderItemsToShow[targetIndex];
    var targetPosition = targetSlide ? targetSlide.offsetLeft : targetIndex * slideWidth;

    if (typeof this.pause === 'function') {
      this.pause();
    }

    this.slider.scrollTo({
      left: targetPosition,
      behavior: quickSwipe || edgeToLast || edgeToFirst ? 'auto' : 'smooth'
    });

    this.currentPage = targetIndex + 1;
    this.update();
    this.bigshockedSwipeGesture = null;

    window.setTimeout(() => {
      this.slider.style.scrollSnapType = '';
      this.update();

      if (typeof this.restartAutoplay === 'function') {
        this.restartAutoplay();
      } else if (
        typeof this.play === 'function' &&
        this.slider &&
        this.slider.getAttribute('data-autoplay') === 'true'
      ) {
        this.play();
      }
    }, quickSwipe || edgeToLast || edgeToFirst ? 120 : 320);
  }

  if (typeof SliderComponent !== 'undefined') {
    patchGestureTracking(SliderComponent);
    SliderComponent.prototype.snapAfterDrag = fixedSnapAfterDrag;
  }

  if (typeof SlideshowComponent !== 'undefined') {
    if (!SlideshowComponent.prototype.bigshockedLoopPositionPatched) {
      var originalSetSlidePosition = SlideshowComponent.prototype.setSlidePosition;

      SlideshowComponent.prototype.setSlidePosition = function (position) {
        if (!this.slider || !this.sliderItemOffset || !this.sliderItemsToShow) {
          return originalSetSlidePosition.call(this, position);
        }

        var currentIndex = getCurrentSlideIndex(this);
        var targetIndex = Math.round(position / this.sliderItemOffset);
        var maxIndex = this.sliderItemsToShow.length - 1;

        if (this.enableSliderLooping && currentIndex === maxIndex && targetIndex === 0) {
          animateSlideshowBoundary(this, 0, 'next');
          return;
        }

        if (this.enableSliderLooping && currentIndex === 0 && targetIndex === maxIndex) {
          animateSlideshowBoundary(this, maxIndex, 'previous');
          return;
        }

        return originalSetSlidePosition.call(this, position);
      };

      SlideshowComponent.prototype.bigshockedLoopPositionPatched = true;
    }

    SlideshowComponent.prototype.snapAfterDrag = fixedSnapAfterDrag;
  }
})();

/* BIGSHOCKED: stable slideshow swipe override */
(function () {
  function isSlideshow(component) {
    return component && component.tagName && component.tagName.toLowerCase() === 'slideshow-component';
  }

  function getCurrentIndex(component) {
    if (isSlideshow(component) && typeof component.currentPage === 'number' && component.currentPage > 0) {
      return component.currentPage - 1;
    }

    if (!component.sliderItemOffset) return 0;
    return Math.round(component.slider.scrollLeft / component.sliderItemOffset);
  }

  function getPointFromTouch(event) {
    if (event && event.changedTouches && event.changedTouches.length) {
      return {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      };
    }

    if (event && event.touches && event.touches.length) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }

    return null;
  }

  function rememberSwipeStart(component, x, y) {
    component.bigshockedStableSwipe = {
      startX: x,
      startY: y,
      lastX: x,
      lastY: y,
      startScroll: component.slider ? component.slider.scrollLeft : 0,
      startIndex: getCurrentIndex(component),
      startTime: Date.now(),
      lastTime: Date.now()
    };
  }

  function rememberSwipeMove(component, x, y) {
    if (!component.bigshockedStableSwipe) return;
    component.bigshockedStableSwipe.lastX = x;
    component.bigshockedStableSwipe.lastY = y;
    component.bigshockedStableSwipe.lastTime = Date.now();
  }

  function setSliderPosition(component, targetIndex, instant) {
    var targetSlide = component.sliderItemsToShow[targetIndex];
    var targetPosition = targetSlide ? targetSlide.offsetLeft : targetIndex * component.sliderItemOffset;

    if (typeof component.pause === 'function') {
      component.pause();
    }

    component.slider.scrollTo({
      left: targetPosition,
      behavior: instant ? 'auto' : 'smooth'
    });

    component.currentPage = targetIndex + 1;
    component.update();

    window.setTimeout(() => {
      component.slider.style.scrollSnapType = '';
      component.update();

      if (typeof component.restartAutoplay === 'function') {
        component.restartAutoplay();
      } else if (
        typeof component.play === 'function' &&
        component.slider &&
        component.slider.getAttribute('data-autoplay') === 'true'
      ) {
        component.play();
      }
    }, instant ? 120 : 320);
  }

  function stableSnapAfterDrag(scrollStart, currentScroll) {
    if (
      !this.slider ||
      !this.sliderItemsToShow ||
      !this.sliderItemsToShow.length ||
      !this.sliderItemOffset
    ) {
      return;
    }

    var slideWidth = this.sliderItemOffset;
    var maxIndex = this.sliderItemsToShow.length - 1;
    var swipe = this.bigshockedStableSwipe;
    var slideshow = isSlideshow(this);
    var startIndex = swipe && typeof swipe.startIndex === 'number' ? swipe.startIndex : getCurrentIndex(this);
    var targetIndex = startIndex;
    var instant = false;

    if (slideshow && swipe) {
      var deltaX = swipe.startX - swipe.lastX;
      var deltaY = swipe.startY - swipe.lastY;
      var horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.08;

      if (horizontal && Math.abs(deltaX) >= 8) {
        targetIndex = deltaX < 0 ? startIndex + 1 : startIndex - 1;
      }
    } else {
      var dragDelta = currentScroll - scrollStart;
      var threshold = slideWidth * 0.1;

      if (Math.abs(dragDelta) >= threshold) {
        targetIndex = dragDelta > 0 ? startIndex + 1 : startIndex - 1;
      }
    }

    if (this.enableSliderLooping) {
      if (targetIndex > maxIndex) {
        targetIndex = 0;
        instant = true;
      }
      if (targetIndex < 0) {
        targetIndex = maxIndex;
        instant = true;
      }
    } else {
      targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));
    }

    setSliderPosition(this, targetIndex, instant);
    this.bigshockedStableSwipe = null;
    this.bigshockedSwipeGesture = null;
  }

  if (typeof SliderComponent !== 'undefined') {
    SliderComponent.prototype.onDragStart = function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      this.isMouseDown = true;
      this.isDragging = false;
      this.startX = event.pageX - this.slider.offsetLeft;
      this.startClientY = event.clientY;
      this.scrollStart = this.slider.scrollLeft;
      rememberSwipeStart(this, event.clientX, event.clientY);
    };

    SliderComponent.prototype.onDragMove = function (event) {
      if (!this.isMouseDown) return;

      rememberSwipeMove(this, event.clientX, event.clientY);

      const x = event.pageX - this.slider.offsetLeft;
      const dragDistance = x - this.startX;
      const verticalDistance = event.clientY - this.startClientY;

      if (!this.isDragging) {
        if (Math.abs(dragDistance) < 8 && Math.abs(verticalDistance) < 8) return;
        if (Math.abs(dragDistance) <= Math.abs(verticalDistance)) return;

        this.isDragging = true;
        this.slider.style.cursor = 'grabbing';
        this.slider.style.userSelect = 'none';
        this.slider.style.scrollSnapType = 'none';
      }

      event.preventDefault();
      const walk = dragDistance * 1.5;
      this.slider.scrollLeft = this.scrollStart - walk;
    };

    SliderComponent.prototype.onDragEnd = function (event) {
      if (event && typeof event.clientX === 'number') {
        rememberSwipeMove(this, event.clientX, event.clientY);
      }

      if (!this.isMouseDown && !this.isDragging) return;

      const wasDragging = this.isDragging;
      this.isMouseDown = false;
      this.isDragging = false;
      this.slider.style.cursor = '';
      this.slider.style.userSelect = '';

      if (!wasDragging && !isSlideshow(this)) {
        this.slider.style.scrollSnapType = '';
        return;
      }

      this.snapAfterDrag(this.scrollStart, this.slider.scrollLeft);
    };

    SliderComponent.prototype.onTouchStart = function (event) {
      var point = getPointFromTouch(event);
      if (!point) return;

      this.touchStartX = point.x;
      this.touchStartY = point.y;
      this.touchScrollStart = this.slider.scrollLeft;
      this.isTouchDragging = false;
      rememberSwipeStart(this, point.x, point.y);
    };

    SliderComponent.prototype.onTouchMove = function (event) {
      var point = getPointFromTouch(event);
      if (!point) return;

      rememberSwipeMove(this, point.x, point.y);

      const diff = this.touchStartX - point.x;
      const verticalDiff = this.touchStartY - point.y;

      if (!this.isTouchDragging) {
        if (Math.abs(diff) < 8 && Math.abs(verticalDiff) < 8) return;
        if (Math.abs(diff) <= Math.abs(verticalDiff)) return;

        this.isTouchDragging = true;
        this.slider.style.scrollSnapType = 'none';
      }

      this.slider.scrollLeft = this.touchScrollStart + diff;
    };

    SliderComponent.prototype.onTouchEnd = function (event) {
      var point = getPointFromTouch(event);
      if (point) {
        rememberSwipeMove(this, point.x, point.y);
      }

      if (!this.isTouchDragging && !isSlideshow(this)) {
        this.slider.style.scrollSnapType = '';
        return;
      }

      this.isTouchDragging = false;
      this.snapAfterDrag(this.touchScrollStart, this.slider.scrollLeft);
    };

    SliderComponent.prototype.snapAfterDrag = stableSnapAfterDrag;
  }

  if (typeof SlideshowComponent !== 'undefined') {
    SlideshowComponent.prototype.setSlidePosition = function (position) {
      if (!this.slider || !this.sliderItemOffset || !this.sliderItemsToShow) return;

      var currentIndex = getCurrentIndex(this);
      var targetIndex = Math.round(position / this.sliderItemOffset);
      var maxIndex = this.sliderItemsToShow.length - 1;
      var instant = false;

      if (this.enableSliderLooping && currentIndex === maxIndex && targetIndex === 0) {
        instant = true;
      }

      if (this.enableSliderLooping && currentIndex === 0 && targetIndex === maxIndex) {
        instant = true;
      }

      if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
      this.setPositionTimeout = setTimeout(() => {
        setSliderPosition(this, targetIndex, instant);
      }, this.announcerBarAnimationDelay);
    };

    SlideshowComponent.prototype.snapAfterDrag = stableSnapAfterDrag;
  }
})();

/* BIGSHOCKED: direct slideshow gesture controller */
(function () {
  if (window.bigshockedDirectSlideshowGestureController) return;
  window.bigshockedDirectSlideshowGestureController = true;

  function getSlides(component) {
    if (!component) return [];
    if (component.sliderItemsToShow && component.sliderItemsToShow.length) {
      return Array.from(component.sliderItemsToShow);
    }
    return Array.from(component.querySelectorAll('.slideshow__slide'));
  }

  function refresh(component) {
    if (component && typeof component.initPages === 'function') {
      component.initPages();
    }
  }

  function currentIndex(component) {
    var slides = getSlides(component);
    if (!slides.length) return 0;

    if (typeof component.currentPage === 'number' && component.currentPage > 0) {
      return Math.max(0, Math.min(component.currentPage - 1, slides.length - 1));
    }

    var offset = component.sliderItemOffset || (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : 0);
    if (!offset) return 0;
    return Math.max(0, Math.min(Math.round(component.slider.scrollLeft / offset), slides.length - 1));
  }

  function setIndex(component, index, instant) {
    var slides = getSlides(component);
    if (!slides.length) return;

    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    var target = slides[index];
    var previousScrollBehavior = component.slider.style.scrollBehavior;

    if (typeof component.pause === 'function') {
      component.pause();
    }

    component.slider.style.scrollSnapType = 'none';
    component.slider.style.scrollBehavior = instant ? 'auto' : previousScrollBehavior;
    component.slider.scrollTo({
      left: target.offsetLeft,
      behavior: instant ? 'auto' : 'smooth'
    });

    component.currentPage = index + 1;
    if (typeof component.update === 'function') {
      component.update();
    }

    window.setTimeout(function () {
      component.slider.style.scrollSnapType = '';
      component.slider.style.scrollBehavior = previousScrollBehavior;
      if (typeof component.update === 'function') {
        component.update();
      }
      if (typeof component.restartAutoplay === 'function') {
        component.restartAutoplay();
      }
    }, instant ? 90 : 340);
  }

  function bind(component) {
    if (!component || component.bigshockedDirectGestureBound) return;

    refresh(component);

    var slider = component.slider || component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    component.slider = slider;
    component.bigshockedDirectGestureBound = true;

    var state = null;

    function start(x, y, scrollLeft, event) {
      refresh(component);
      state = {
        startX: x,
        startY: y,
        lastX: x,
        lastY: y,
        startScroll: scrollLeft,
        startIndex: currentIndex(component),
        dragging: false,
        horizontal: false
      };

      if (event) {
        event.stopImmediatePropagation();
      }
    }

    function move(x, y, event) {
      if (!state) return;

      state.lastX = x;
      state.lastY = y;

      var dx = state.startX - x;
      var dy = state.startY - y;

      if (!state.dragging) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) {
          if (event) event.stopImmediatePropagation();
          return;
        }

        state.horizontal = Math.abs(dx) > Math.abs(dy) * 1.08;
        state.dragging = state.horizontal;

        if (!state.horizontal) {
          return;
        }

        component.slider.style.scrollSnapType = 'none';
        if (typeof component.pause === 'function') {
          component.pause();
        }
      }

      if (!state.horizontal) return;

      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      component.slider.scrollLeft = state.startScroll + dx;
    }

    function end(event) {
      if (!state) return;

      var dx = state.startX - state.lastX;
      var dy = state.startY - state.lastY;
      var horizontal = Math.abs(dx) > Math.abs(dy) * 1.08;

      if (event) {
        event.stopImmediatePropagation();
      }

      if (!horizontal || Math.abs(dx) < 8) {
        component.slider.style.scrollSnapType = '';
        state = null;
        return;
      }

      var targetIndex = dx > 0 ? state.startIndex + 1 : state.startIndex - 1;
      var edgeJump = targetIndex < 0 || targetIndex >= getSlides(component).length;

      setIndex(component, targetIndex, edgeJump);
      state = null;
    }

    slider.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches.length) return;
        start(event.touches[0].clientX, event.touches[0].clientY, slider.scrollLeft, event);
      },
      { capture: true, passive: true }
    );

    slider.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || !event.touches.length) return;
        move(event.touches[0].clientX, event.touches[0].clientY, event);
      },
      { capture: true, passive: false }
    );

    slider.addEventListener(
      'touchend',
      function (event) {
        if (event.changedTouches && event.changedTouches.length && state) {
          state.lastX = event.changedTouches[0].clientX;
          state.lastY = event.changedTouches[0].clientY;
        }
        end(event);
      },
      { capture: true }
    );

    slider.addEventListener(
      'mousedown',
      function (event) {
        if (event.button !== 0) return;
        start(event.clientX, event.clientY, slider.scrollLeft, event);
      },
      true
    );

    window.addEventListener(
      'mousemove',
      function (event) {
        move(event.clientX, event.clientY, event);
      },
      true
    );

    window.addEventListener(
      'mouseup',
      function (event) {
        if (state) {
          state.lastX = event.clientX;
          state.lastY = event.clientY;
        }
        end(event);
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('slideshow-component').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
